import { AuthContainer } from '@sleepstation/auth-jwt'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useContainer } from 'unstated-next'
import { useQuery } from 'urql'
import CONTENT from '../../../content'
import ContentContext from '../../context/ContentContext'
import RoutingContext from '../../context/RoutingContext'
import { RoutingQuery } from '../../graphql/documents'
import { wasResultSuccessful } from '../../utils/request'
import LoadOverlay from '../shared/LoadOverlay'
import App from './App'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const prepare = ({ isAuthorised, result }) => {
  const isLoaded = isAuthorised && wasResultSuccessful(result)

  if (!isLoaded) {
    return {
      isLoaded: false,
    }
  }

  const { routing: appRouting } = result.data

  const routing = {
    appRouting,
  }

  const content = CONTENT

  return {
    isLoaded,
    content,
    routing,
  }
}

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AppModule = ({ initalData, children }) => {
  const { enrolmentId } = initalData
  const { isAuthorised } = useContainer(AuthContainer)

  const [result] = useQuery({
    query: RoutingQuery,
  })

  const { isLoaded, routing, content } = useMemo(
    () => prepare({ isAuthorised, result }),
    [isAuthorised, result]
  )

  if (!isLoaded) {
    return <LoadOverlay />
  }

  return (
    <RoutingContext.Provider value={routing}>
      <ContentContext.Provider value={content}>
        <App enrolmentId={enrolmentId}>{children}</App>
      </ContentContext.Provider>
    </RoutingContext.Provider>
  )
}

AppModule.propTypes = {
  initalData: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
}

export default AppModule
